import { render, staticRenderFns } from "./draw-map.vue?vue&type=template&id=0c56547e&scoped=true"
import script from "./draw-map.vue?vue&type=script&lang=js"
export * from "./draw-map.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c56547e",
  null
  
)

export default component.exports